import axios from 'axios'
import { pumatracApi } from '../utils/axios-config'

export default {
  get ({id, language = 'en'}) {
    return pumatracApi.get(`/workouts/${id}/`, {
      headers: {
        common: {
          'Accept-Language': language
        }
      }
    })
  },

  all ({params = {}, language = 'en'} = {}) {
    return pumatracApi.get(`/workouts/`, {
        params : params,
        headers: {
            common: {
            'Accept-Language': language
            }
        }
    })
  },

  rate({id, ratingData}) {
    const data = {
        workoutFeedback: ratingData
    }
    return pumatracApi.post(`/workouts/${id}/ratings`, data, {})
  },

  favourite({id}) {
      return pumatracApi.post(`/workouts/${id}/favourite`)
  },

  unfavourite({id}) {
    return pumatracApi.delete(`/workouts/${id}/favourite`)
  }
}
